import React from 'react'

export const useTimer = (duration, autoStart = true) => {
  const [timeRemaining, setTimeRemaining] = React.useState(duration)
  const [start, setStart] = React.useState(autoStart)

  const startTimer = React.useCallback(() => {
    if (autoStart) return

    setStart(true)
  }, [autoStart])

  React.useEffect(() => {
    if (!start) return

    const interval = setInterval(() => {
      setTimeRemaining(prev => {
        const newTime = prev - 1000

        if (newTime < 0) {
          clearInterval(interval)
          return prev
        }
        return prev - 1000
      })
    }, 1000)
  }, [start])

  return { timeRemaining: timeRemaining / 1000, startTimer }
}
